import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PatientFacility } from '../../models/patient-details.model';

@Component({
  selector: 'app-patient-facilities',
  templateUrl: './patient-facilities.component.html',
  styleUrls: ['./patient-facilities.component.scss'],
  standalone: false
})
export class PatientFacilitiesComponent implements OnInit, OnChanges {
  @Input() facilities: PatientFacility[] = [];

  facilitiesList: PatientFacility[] = [];

  ngOnInit(): void {
    this.filterActiveFacilities();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['facilities']) {
      this.filterActiveFacilities();
    }
  }

  private filterActiveFacilities(): void {
    if (this.facilities && Array.isArray(this.facilities)) {
      // Show all facilities, not just active ones
      this.facilitiesList = this.facilities.filter((f) => f != null);
    } else {
      this.facilitiesList = [];
    }
  }
}